/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Entity = {
    INDIVIDUAL: 'INDIVIDUAL',
    LEGAL: 'LEGAL'
} as const;
export type Entity = typeof Entity[keyof typeof Entity];

